import { BodyRegular } from '@common/body';
import { H3 } from '@common/headline';

export const QuizPrimer = (): JSX.Element => (
  <div className="text-center text-blue">
    <div className="mb-8">
      <H3>Losing weight is hard, let us make it feel easier</H3>
    </div>
    <div className="mb-8">
      <BodyRegular>
        Your weight loss journey starts with our health quiz. This helps us
        understand a little more about you so we can help you achieve the
        results you want.
      </BodyRegular>
    </div>
    <div className="mb-8">
      <BodyRegular>
        We use your quiz answers to tailor our advice and support once you start
        the programme, to ensure you lose weight and keep it off.
      </BodyRegular>
    </div>
  </div>
);
